import { useQuery } from '@tanstack/react-query'
import { monitorApi } from '@/api/monitor'

export function useCurrentMetrics() {
  return useQuery({
    queryKey: ['monitoring-current'],
    queryFn: monitorApi.current,
    refetchInterval: 30_000,
  })
}

export function useMetricsHistory(node: string | undefined, hours = 24) {
  return useQuery({
    queryKey: ['monitoring-history', node, hours],
    queryFn: () => monitorApi.history(node!, hours),
    enabled: !!node,
    refetchInterval: 60_000,
  })
}
